import IntroPlayer from '../IntroPlayer'
import Gallery from '../Gallery'
import NavBar from '../NavBar'

import LivePlayer from '../LivePlayer'
import './index.css'

const VideoPlayer = () => {
  const liveVideo = 'https://youtu.be/-zdMvObQYNI'

  return (
    <div className="body">
      <NavBar />
      <div id="HomePage">
        <div className="marry">
          <h1 className="heading">Sai</h1>
          <img
            src="https://res.cloudinary.com/dzfzf9c4u/image/upload/v1639746097/wedding-rings_1_gkst4o.png"
            alt="ring"
            className="ring-img"
          />
          <p className="weds">Weds</p>
          <h1 className="heading-1">Sruthi</h1>
        </div>
        <p className="para">ARE GETTING MARRIED</p>
        <p className="para-1">
          27th December at Ballipadu,Tallapudi Mandalam,West Godavari Dst.
        </p>
      </div>
      <div id="InvitationPage">
        <h1 className="invitation-head">Invitation</h1>
        <hr className="hr-line" />
        <IntroPlayer />
        <p className="invite-para">
          Mr. pedda bhimayya palli & Mrs.sasirekha palli solicit your blessings
          and request the pleasure of your company at the Wedding Ceremony of
          their youngest grandson.
        </p>
        <h1 className="bride">Sai</h1>
        <p className="father">
          (S/o Mr.Govinda Rao & Mrs.Venkata Lakshmi Palli)
        </p>
        <p className="father-1">With</p>
        <h1 className="bride">Sruthi</h1>
        <p className="father">
          (S/o Mr.Subbarao Rao & Mrs.Malleswari Nallamolu)
        </p>
        <p className="invite-para">
          Come and celebrate with us amid music, joy and lots of love. Grace us
          with your presence and shower the new couple with wishes and blessings
          as they embark upon a new journey.
        </p>
      </div>
      <div id="wedding-ceremony">
        <div className="wedding-card">
          <h1 className="ceremony">Wedding Ceremony</h1>
          <hr className="ceremony-line" />
          <img
            src="https://res.cloudinary.com/dzfzf9c4u/image/upload/v1640542902/e48f914d-3111-4325-84a8-09d2edf2dd6b_ri6rwq.jpg"
            alt="marry"
            className="marry-img"
          />
          <div className="details">
            <div className="each-item">
              <h1 className="head">Date</h1>
              <p className="details-para">
                27<sup>th</sup> December,2021
              </p>
            </div>
            <div className="each-item">
              <h1 className="head">Time</h1>
              <p className="details-para">10:30 in the morning</p>
            </div>
            <div className="each-item">
              <h1 className="head">Venue</h1>
              <p className="details-para">
                Ballipadu,Tallapudi Mandalam, West Godavari Dst.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Gallery />

      <LivePlayer liveVideo={liveVideo} />
    </div>
  )
}

export default VideoPlayer
